(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 300);
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        if (fresh && drawer) {
          drawer.innerHTML = fresh.innerHTML;
        }
      })
      .then(updateCount);
  }

  function updateCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  // Open / close
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshDrawer().then(openDrawer); }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeDrawer(); }

    // Drawer quantity buttons (event delegation, survives re-render)
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.getAttribute('data-line');
      var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      if (qty < 0) qty = 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(refreshDrawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // AJAX add to cart (fallback: normal POST still works without JS)
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-to-cart]');
      var label = productForm.querySelector('[data-add-label]');
      var original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Ekleniyor...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () { return refreshDrawer(); })
        .then(function () {
          if (label) label.textContent = 'Sepete Eklendi';
          openDrawer();
          setTimeout(function () {
            if (label) label.textContent = original;
            if (btn) btn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          if (label) label.textContent = (err && err.description) ? err.description : 'Hata — tekrar deneyin';
          if (btn) btn.disabled = false;
          setTimeout(function () { if (label) label.textContent = original; }, 2500);
        });
    });

    // Variant select -> update price
    var select = productForm.parentElement.parentElement.querySelector('[data-variant-select]') || document.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var priceWrap = document.querySelector('[data-price-wrap]');
        if (priceWrap && opt.dataset.price) {
          priceWrap.innerHTML = '<span class="price">' + opt.dataset.price + '</span>';
        }
      });
    }
  }

  // Product gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = thumb.getAttribute('data-thumb');
    });
  });
})();
